import React, {Fragment} from 'react';
import CardGrid from '../common/card-grid/CardGrid';
import NextPageButton from '../common/NextPageButton';
import CardGridUnit from '../common/card-grid/CardGridUnit';
import ProductStatesFilter from './filter/ProductStatesFilter';
import ProductFilter from './filter/ProductFilter';
import NotInterruptingDisfunctions from './filter/NotInterruptingDisfunctionsFilter';
import InterruptingDisfunctions from './filter/InterruptingDisfunctionsFilter';
import ShiftsFilter from './filter/ShiftsFilter';

const FilterSettings = (props) => (
  <Fragment>
    <CardGrid>
      <CardGridUnit height={'50%'} size={1}>
        <ProductStatesFilter {...props} />
      </CardGridUnit>
      <CardGridUnit height={'50%'} size={4 / 13}>
        <NotInterruptingDisfunctions {...props} />
      </CardGridUnit>
      <CardGridUnit height={'50%'} size={3 / 13}>
        <InterruptingDisfunctions {...props} />
      </CardGridUnit>
      <CardGridUnit height={'50%'} size={3 / 13}>
        <ProductFilter {...props} />
      </CardGridUnit>
      <CardGridUnit height={'50%'} size={3 / 13}>
        <ShiftsFilter {...props} />
      </CardGridUnit>
    </CardGrid>
    <NextPageButton hide />
  </Fragment>
);

export default FilterSettings;
